module.exports = __webpack_public_path__ + "img/20190710164005QQ截图20190709232637.da671708.png";